import { createApi } from '@reduxjs/toolkit/query/react';

import {
  LoggerEndpoints as Endpoints,
  type ClearSystemLogsRequest,
  type ClearSystemLogsResponse,
  type ExportSystemLogsByPeriodToExcelRequest,
  type ExportSystemLogsByPeriodToExcelResponse,
  type GetLogByIdRequest,
  type GetLogByIdResponse,
  type GetLogsRequest,
  type GetLogsResponse,
  type GetSystemLogsByPeriodRequest,
  type GetSystemLogsByPeriodResponse,
} from '@app/api/Logger/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

export const loggerApi = createApi({
  reducerPath: 'loggerApi',
  baseQuery: createApiBaseQuery('/Logger'),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetSystemLogsByPeriod]: query<
      GetSystemLogsByPeriodResponse,
      GetSystemLogsByPeriodRequest
    >({
      query: (params) => ({
        url: Endpoints.GetSystemLogsByPeriod,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ExportSystemLogsByPeriodToExcel]: query<
      ExportSystemLogsByPeriodToExcelResponse,
      ExportSystemLogsByPeriodToExcelRequest
    >({
      query: (params) => ({
        url: Endpoints.ExportSystemLogsByPeriodToExcel,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ClearSystemLogs]: mutation<
      ClearSystemLogsResponse,
      ClearSystemLogsRequest
    >({
      query: (params) => ({
        url: Endpoints.ClearSystemLogs,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetLogs]: mutation<GetLogsResponse, GetLogsRequest>({
      query: (params) => ({
        url: Endpoints.GetLogs,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetLogById]: query<GetLogByIdResponse, GetLogByIdRequest>({
      query: (params) => ({
        url: Endpoints.GetLogs,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useGetSystemLogsByPeriodQuery,
  useLazyGetSystemLogsByPeriodQuery,
  useExportSystemLogsByPeriodToExcelQuery,
  useLazyExportSystemLogsByPeriodToExcelQuery,
  useClearSystemLogsMutation,
  useGetLogsMutation,
  useGetLogByIdQuery,
  useLazyGetLogByIdQuery,
} = loggerApi;
